<template>
  <div class="page-product">
    <el-row class="m-crumbs">
      <Crumbs />
    </el-row>
    <el-row>
      <el-col :span="19">
        <el-row>
          <Classify />
        </el-row>
        <el-row>
          <ProductList />
        </el-row>
      </el-col>
      <el-col :span="5">
        <GuessYouLike />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Crumbs from "@/components/products/Crumbs.vue";
import Classify from "@/components/products/Classify.vue";
import ProductList from "@/components/products/ProductList.vue";
import GuessYouLike from "@/components/products/GuessYouLike.vue";
export default {
  components: {
    Crumbs,
    Classify,
    ProductList,
    GuessYouLike,
  },
};
</script>
<style lang="scss">
@import "@/assets/css/products/index.scss";
</style>
